import { render } from "./Svgall.vue?vue&type=template&id=5c1893eb"
import script from "./Svgall.vue?vue&type=script&lang=js"
export * from "./Svgall.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__